"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var highlightTerm = function highlightTerm(text, term) {
  if (_lodash["default"].isEmpty(term)) {
    return text;
  }
  var pattern = new RegExp(term, 'gi');
  var a = text.split(pattern);
  var r = text.match(pattern);
  if (!r) {
    return text;
  }
  var comp = _lodash["default"].reduce(a, function (acc, val, index) {
    return _lodash["default"].concat(acc, _lodash["default"].concat(val, r[index] ? /*#__PURE__*/_react["default"].createElement("b", {
      key: index
    }, r[index]) : null));
  }, '');
  return _lodash["default"].compact(comp);
};
var _default = exports["default"] = highlightTerm;